import React, { useMemo } from "react";
import { useIsServer } from "../../hooks";
import { Swiper, SwiperSlide } from "swiper/react";
import { classNames, getClassConditionalAppend, getColors, getContainerClassPerMaxWidth, groomRichTextHTML, } from "../../utils";
import { Container, ContainerFW } from "../global";
import { Disclaimer } from "./Disclaimer/Disclaimer";
import { Card } from "./Card/Card";
export const M34HowItWorks = ({ slides, title, titleTitleAlignment, subTitle, subTitleTitleAlignment, subTitleColor, backgroundColor, buttonLabel, buttonUrl, textDisclaimer, openInNewTab, titleColor, buttonStyle, containerMaxWidth, iconStyle = "numbered-steps-with-circles", isSwiper = true, }) => {
    const isServer = useIsServer();
    const { bgColor } = getColors(backgroundColor);
    const containerMaxWidthClass = getContainerClassPerMaxWidth(containerMaxWidth);
    const containerExtraClass = getClassConditionalAppend(containerMaxWidthClass);
    const handleSliderItems = useMemo(() => {
        if (slides.length > 4) {
            return 4.2;
        }
        return slides.length;
    }, [slides.length]);
    const groomedTitle = isServer
        ? title
        : groomRichTextHTML(title, { replace: ["p", "div"] });
    const groomedSubTitle = isServer
        ? subTitle
        : groomRichTextHTML(subTitle, { replace: ["p", "div"] });
    const componentClassname = classNames("how-it-works-root", {
        "how-it-works-root--no-swiper": !isSwiper,
        [`how-it-works-root--${iconStyle}`]: !!iconStyle,
    });
    const slidesHaveCustomIcon = iconStyle === "custom-step-icons";
    return (React.createElement("div", { className: componentClassname },
        React.createElement(ContainerFW, { className: containerExtraClass, backgroundColor: bgColor },
            React.createElement(Container, { className: containerExtraClass },
                groomedTitle && (React.createElement("h3", { className: "h3-semi-bold", style: {
                        "--title-text-alignment": titleTitleAlignment,
                        "--title-text-color": titleColor,
                    }, dangerouslySetInnerHTML: { __html: groomedTitle } })),
                groomedSubTitle && (React.createElement("p", { className: "copy-lp", style: {
                        "--subTitle-text-alignment": subTitleTitleAlignment,
                        "--subTitle-text-color": subTitleColor,
                    }, dangerouslySetInnerHTML: {
                        __html: groomedSubTitle,
                    } })),
                React.createElement("div", { className: "how-it-works-root__contentWrapper" },
                    React.createElement(ConditionalSwiper, { slides: slides, isSwiper: isSwiper, numSliderItems: handleSliderItems, slidesHaveCustomIcon: slidesHaveCustomIcon }),
                    React.createElement(Disclaimer, { buttonDesign: buttonStyle, buttonLabel: buttonLabel, buttonUrl: buttonUrl, textDisclaimer: textDisclaimer, openInNewTab: openInNewTab }))))));
};
const ConditionalSwiper = ({ slides, isSwiper, numSliderItems, slidesHaveCustomIcon, }) => {
    if (isSwiper) {
        return (React.createElement(Swiper, { breakpoints: {
                375: {
                    slidesPerView: 1.25,
                    spaceBetween: 10,
                },
                601: {
                    slidesPerView: 2.4,
                    spaceBetween: 10,
                },
                1025: {
                    slidesPerView: numSliderItems,
                    spaceBetween: 10,
                },
            } }, Array.isArray(slides) &&
            slides.map((slide, index) => (React.createElement(SwiperSlide, { key: index, className: "how-it-works-root__card" },
                React.createElement(Card, { slideNumber: index + 1, comments: slide.comments, iconUrl: slide.iconUrl, showCustomIcon: slidesHaveCustomIcon }))))));
    }
    return (React.createElement("div", { className: "how-it-works-root__carddeck" }, Array.isArray(slides) &&
        slides.map((slide, index) => (React.createElement("div", { key: index, className: "how-it-works-root__card" },
            React.createElement(Card, { slideNumber: index + 1, comments: slide.comments, iconUrl: slide.iconUrl, showCustomIcon: slidesHaveCustomIcon, className: "" }))))));
};
